import types from './actionTypes';

export const toggleLeftPanel = toggle => ({
    type: types.TOGGLE_LEFT_PANEL,
    payload: {
        toggle,
    },
});
